import React from 'react'
import Text from '@component/Text/Text'
import useQueryFetchMe from '@hook/query/account/useQueryFetchMe'

interface IProps {
    className?: string
}

const InvoiceCountDown: React.FC<IProps> = ({className}) => {
    const {data: me} = useQueryFetchMe(undefined, false)
    return (
        <div
            className={
                'absolute bottom-0 md:bottom-[-4px] left-[15px] h-[14px] min-h-[14px] bg-red_shade dark:bg-dark_red_shade px-[4px] rounded-[7px]'
            }>
            <Text className={'text-white text-ti4 text-center leading-[14px]'}>{me?.pending_invoices}</Text>
        </div>
    )
}

export default InvoiceCountDown
